import { Component } from '@angular/core';

@Component({
  standalone: false,
  selector: 'suvo-bi-skeleton-pie',
  templateUrl: './skeleton-pie.component.html',
  styleUrls: ['./skeleton-pie.component.scss'],
})
export class SkeletonPieComponent {}
